export default {
    cn: {
        ruleItem: {
            currentSetting: '当前设定',
            levelSetting: '级设定',
            rule: '规则',
            toOriginalAccount: '分配給原始账号',
            toTargetAccount: '分配给指定账号',
            customTheMoney: '自定金额',
            addRule: '添加规则',
            remove: '刪除',
            fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            maxlevel_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
            fixamountnonvip: '固定金额(普通组别)',
            fixamountnonvip_desc: '針 對 普 通 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            fixamountvip: '固定金額(VIP 組別)',
            fixamountvip_desc: '針 對 V I P 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            notExist: '不存在',
            notSalesSet: '没有设定销售资料',
        }
    },
    hk: {
        ruleItem: {
            currentSetting: '当前設定',
            levelSetting: '級設定',
            rule: '規則',
            toOriginalAccount: '分配給原始賬號',
            toTargetAccount: '分配給指定賬號',
            customTheMoney: '自定金額',
            addRule: '添加規則',
            remove: '刪除',
            notExist: '不存在',
            notSalesSet: '沒有設定銷售資料',
            fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            maxlevel_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
            fixamountnonvip: '固定金額(普通组别)',
            fixamountnonvip_desc: '針 對 普 通 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            fixamountvip: '固定金額(VIP 組別)',
            fixamountvip_desc: '針 對 V I P 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。'
        }
    },
    en: {
        ruleItem: {
            currentSetting: 'Current Setting',
            levelSetting: 'Level Setting',
            rule: 'Rule',
            toOriginalAccount: 'To Original Account',
            toTargetAccount: 'To Target Account',
            customTheMoney: 'Custom The Money',
            addRule: 'Add Rule',
            remove: 'Remove',
            notExist: 'Not Exist',
            notSalesSet: 'Not sales data are set',
            fixamount_desc: 'fixamount_desc',
            maxlevel_desc: 'maxlevel_desc',
            fixamountnonvip: 'Fixamountnonvip',
            fixamountnonvip_desc: 'fixamountnonvip_desc',
            fixamountvip: 'Fixamountvip',
            fixamountvip_desc: 'fixamountvip_desc'
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/Sale/ruleItem.js